
import Component from "./index.vue"
export default {
    id: "guide-to-presentation", // (required) uuid
    icon: require("./icon.svg"), // (required) url to tool icon
    title: "Convert Guide to Interactive Presentation", // (required) Title shown on content tools view
    description: "Convert content using the old Guide format to the newest Interactive Presentation format", // (required) Operation description
    available: true, // (optional) set to true if tool is available to use in the platform
    Component // (required) VueComponent to show when operation is selected
}